import { Loader2 } from "lucide-react";

import { cn } from "../../lib/utils";

/** Centered spinner for full-page / full-section loading states.
 *  Skeletons are preferred when the layout is known; this is the
 *  fallback for "we don't know how big the result is yet." */
export function PageSpinner({ label }: { readonly label?: string }) {
  return (
    <div className="flex min-h-[40vh] items-center justify-center">
      <div className="flex flex-col items-center gap-2 text-muted">
        <Loader2 className="h-5 w-5 animate-spin" aria-hidden="true" />
        {label && <span className="text-sm">{label}</span>}
      </div>
    </div>
  );
}

/** Inline spinner used inside buttons / rows. */
export function InlineSpinner({ className }: { readonly className?: string }) {
  return <Loader2 className={cn("h-4 w-4 animate-spin", className)} aria-hidden="true" />;
}
